export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"msapplication-TileColor","content":"#da532c"},{"name":"msapplication-config","content":"/favicons/browserconfig.xml"},{"name":"theme-color","content":"#ffffff"},{"name":"description","content":"Ohne Termin oder Wartezeit bei der Zulassungsstelle. Abmeldebescheinigung sofort verfügbar. Auto online abmelden."}],"link":[{"rel":"apple-touch-icon","sizes":"180x180","href":"/favicons/apple-touch-icon.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicons/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicons/favicon-16x16.png"},{"rel":"manifest","href":"/favicons/site.webmanifest"},{"rel":"mask-icon","href":"/favicons/safari-pinned-tab.svg","color":"#DD0000"},{"rel":"shortcut icon","href":"/favicons/favicon.ico"}],"style":[],"script":[{"type":"text/javascript","innerHTML":"\n            window.uetq = window.uetq || [];\n            window.uetq.push('consent', 'default', {\n              'ad_storage': 'granted'\n            });\n          "},{"type":"text/javascript","innerHTML":"\n            (function(w,d,t,r,u)\n            {\n                var f,n,i;\n                w[u]=w[u]||[],f=function()\n                {\n                    var o={ti:\"97108870\", enableAutoSpaTracking: true};\n                    o.q=w[u],w[u]=new UET(o),w[u].push(\"pageLoad\")\n                },\n                n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function()\n                {\n                    var s=this.readyState;\n                    s&&s!==\"loaded\"&&s!==\"complete\"||(f(),n.onload=n.onreadystatechange=null)\n                },\n                i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)\n            })\n            (window,document,\"script\",\"//bat.bing.com/bat.js\",\"uetq\");\n          "}],"noscript":[],"title":"Kfz-Abmeldung Online (Außerbetriebsetzung)","htmlAttrs":{"lang":"de"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = false

export const granularCachedData = false

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false